import Toast from "../../component/toastify/Index";
import axios from "../../axios/interceptor";

export const getCrifScore = async (clientId) => {
    try {
        // NOTE: Backend not yet implemented, returning dummy data
        const dummyData = Math.floor(Math.random() * (1000 - 300 + 1)) + 300; // Random score between 300 and 1000
        return { isSuccess: true, crifScore: dummyData };
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
        return { isSuccess: false, crifScore: null };
    }
};

export const getManualCrifScore = async (clientId) => {
    try {
        const response = clientId ? await axios.get(`customer/crif/manual-score?clientId=${clientId}`) : await axios.get(`customer/crif/manual-score`);
        return { isSuccess: response.data.isSuccess, crifScore: response.data.score, lastUpdated: response.data.lastUpdated };
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
        return { isSuccess: false, crifScore: null, lastUpdated: null };
    }
};

export const saveCrifScore = async (crifScore, clientId) => {
    try {
        const response = clientId ? await axios.post(`customer/crif/save-score?clientId=${clientId}`, { crifScore }) : await axios.post("customer/crif/save-score", { crifScore });
        return { isSuccess: response.data.isSuccess, crifScore: response.data.score, lastUpdated: response.data.lastUpdated };
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
        return { isSuccess: false, crifScore: null, lastUpdated: null };
    }
};